var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step-container" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "form-group currentComponent col-xs-12" }, [
        _c("label", [_vm._v("I am in the")]),
        _vm._v(" "),
        _c(
          "label",
          {
            directives: [
              {
                name: "popover",
                rawName: "v-popover.hover",
                value: _vm.tooltips.activeComponent,
                expression: "tooltips.activeComponent",
                modifiers: { hover: true },
              },
            ],
            staticClass: "radio-inline",
          },
          [
            _c("input", {
              attrs: {
                type: "radio",
                name: "currentComponent",
                value: "active",
              },
              domProps: {
                checked: this.formData.currentComponent === "active",
              },
              on: {
                change: function ($event) {
                  return _vm.setFormData({ currentComponent: "active" })
                },
              },
            }),
            _vm._v("\n        Active Component\n      "),
          ]
        ),
        _vm._v(" "),
        _c(
          "label",
          {
            directives: [
              {
                name: "popover",
                rawName: "v-popover.hover",
                value: _vm.tooltips.reserveComponent,
                expression: "tooltips.reserveComponent",
                modifiers: { hover: true },
              },
            ],
            staticClass: "radio-inline",
          },
          [
            _c("input", {
              attrs: {
                type: "radio",
                name: "currentComponent",
                value: "reserve",
              },
              domProps: {
                checked: this.formData.currentComponent === "reserve",
              },
              on: {
                change: function ($event) {
                  return _vm.setFormData({ currentComponent: "reserve" })
                },
              },
            }),
            _vm._v("\n        Reserve Component\n      "),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group col-xs-12" }, [
        _c("label", [
          _vm._v("\n        and will\n        "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "popover",
                  rawName: "v-popover.hover",
                  value: _vm.tooltips.separate,
                  expression: "tooltips.separate",
                  modifiers: { hover: true },
                },
              ],
              staticClass: "text-underline",
            },
            [_vm._v("separate")]
          ),
          _vm._v("\n        or retire from the\n      "),
        ]),
        _vm._v(" "),
        _c(
          "select",
          {
            staticClass: "form-control input-sm",
            domProps: { value: _vm.formData.endingComponent },
            on: {
              change: function ($event) {
                return _vm.setFormData({ endingComponent: $event.target.value })
              },
            },
          },
          [
            _c("option", { attrs: { value: "active" } }, [
              _vm._v("Active Component"),
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "reserve" } }, [
              _vm._v("Reserve Component"),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-offset-4 col-sm-4" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-lg btn-primary btn-block",
            attrs: { type: "button" },
            on: { click: _vm.setNextStep },
          },
          [
            _vm._v("\n        Get Started\n        "),
            _c("i", { staticClass: "fa fa-caret-right" }),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }